import React, { PropTypes } from 'react';
import PageHeader from '../../shared/PageHeader';
import DetailHeader from '../../shared/DetailHeader';
import ContentRow from './ContentRow';
import { getCurrentLanguage } from '../../../localData';
import localize from '../../../localize';
import styles from './content-list.scss';
import CSSModules from 'react-css-modules';

const l = (key) => {
    const str = `${getCurrentLanguage()}.components.ContentList.${key}`;
    return localize(str);
};

const ContentList = ({ store, params, relay }) => {
    let categories = [];
    if (!!store.contents && store.contents.edges.length) {
        categories = store.contents.edges.map(edge => {
            const url = `/${getCurrentLanguage()}/content/${ edge.node.id }/objects`;
            return <ContentRow key={ edge.node.id } text={edge.node.ConTxt} url={url} />;
        });
    }
    
    return (
        <div className="categories">
            <DetailHeader
                relay={ relay }
                detail={{
                    title: l(params.conType),
                }}
                simple
                isList
            />
            <div id="detailHeader">
                <PageHeader
                    store={ store }
                    title={ l(params.conType) }
                />
            </div>
            {
                categories.length &&
                <div styleName="list">
                    <ul className="nav-list">
                        { categories }
                    </ul>
                </div>
            }
        </div>
    );
};

ContentList.propTypes = {
    store: PropTypes.object.isRequired,
    params: PropTypes.object.isRequired,
    relay: PropTypes.object.isRequired,
};

export default CSSModules(ContentList, styles);


// WEBPACK FOOTER //
// ./app/components/Content/List/ContentList.jsx